/**
 * @ngdoc directive
 * @name ce-app:StickyHeaderDirective
 *
 * @description
 *
 *
 * @restrict A
 * */
import angular from 'angular';

/* @ngInject */
export default function StickyClassDirective($window) {
    return {
        restrict: 'A',
        scope: {
            hideableSibling: '@',
            stickyClass: '@',
            containingElementId: '@'
        },
        link: function (scope, elem) {
            var stickyElement, stickyClass, containingElem, hideableElement;
            stickyElement = angular.element(elem);
            stickyClass = scope.stickyClass;
            containingElem = document.getElementById(scope.containingElementId);
            hideableElement = document.getElementsByClassName(scope.hideableSibling)[0];

            var stickyFunctionality = function () {
                if (hideableElement) {
                    if (hideableElement.offsetHeight !== 0) {
                        if (hideableElement.getBoundingClientRect().bottom <= 0) {
                            stickyElement.addClass(stickyClass);
                        } else {
                            stickyElement.removeClass(stickyClass);
                        }
                    } else {
                        if (containingElem.previousElementSibling.getBoundingClientRect().bottom <= 0) {
                            stickyElement.addClass(stickyClass);
                        } else {
                            stickyElement.removeClass(stickyClass);
                        }
                    }
                }
            };

            if ($window.addEventListener) {
                $window.addEventListener('scroll', stickyFunctionality);
            } else {
                $window.attachEvent('scroll', stickyFunctionality);
            }
        }
    };
}
